var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfileIcon = function SvgProfileIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 17,
    fill: "none",
    viewBox: "0 0 10 17"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.864,
    cy: 3.864,
    r: 3.864,
    fill: "#1A1818"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1818",
    d: "M0 13a5 5 0 0 1 10 0v4H0z"
  })));
};
export default SvgProfileIcon;